import React from 'react';

type ContextValue = {
  isCreateOpen: boolean;
  isEditOpen: boolean;
  isOpen: boolean;
  openCreate: () => void;
  openEdit: (id: string) => void;
  getIsEditing: (id: string) => boolean;
  close: () => void;
};

const Context = React.createContext({} as ContextValue);

type Props = {
  children: React.ReactNode;
};

export function PayConditionsListContextProvider({ children }: Props) {
  const [openForm, setOpenForm] =
    React.useState<'create' | 'edit' | null>(null);
  const [editId, setEditId] = React.useState('');

  const isCreateOpen = openForm === 'create';
  const isEditOpen = openForm === 'edit';
  const isOpen = isCreateOpen || isEditOpen;

  const openCreate = React.useCallback(() => {
    setOpenForm('create');
  }, []);

  const openEdit = React.useCallback((id: string) => {
    setOpenForm('edit');
    setEditId(id);
  }, []);

  const getIsEditing = (id: string) => {
    return isEditOpen && editId === id;
  };

  const close = React.useCallback(() => {
    setOpenForm(null);
  }, []);

  return (
    <Context.Provider
      value={{
        isCreateOpen,
        isEditOpen,
        isOpen,
        openCreate,
        openEdit,
        close,
        getIsEditing,
      }}
    >
      {children}
    </Context.Provider>
  );
}

export function usePayConditionsListContext() {
  return React.useContext(Context);
}
